export const highRisedBuilding = {
	table1: {
		heading: 'FOR HIGH RISED BUILDING',
		sn: 'S.N.',
		description: 'Description',
		iee: 'IEE',
		eia: 'EIA',
		remarks: 'Remarks',
		lessThan5000: 'Less than 5000 m2',
		fiveThousand: '5000~10000 m2',
		na: 'N. A.',
		applicable: 'Applicable',
		greaterThan10000: '>10000 m2',
		landArea: 'Land Area',
		lessThan1Hectare: 'Less Than 1 hectare',
		OneHectare4Hectare: '1 Hectare ~ 4 Hectare',
		greaterThan4Hectare: '> 4 Hectare',
		approachRoad: 'Approach Road',
		front: 'Front',
		side: 'Side',
		builtUpArea: 'Build up Area',
		openArea: 'Open Area',
		sixMeter: '6 m.',
		threeMeter: '3 m.',
		fiftyPercent: '50%',
		thirtyPercent: '30%',
		twentyPercent: '20%',
		greeneryArea: 'Greenery Area',
		motorPark: 'Motor Park',
		heightAndWidthOfWallCoreBuilding: 'Height and Width of wall core-Building',
		calculatedEarthquakeLateralLoad: 'Calculated Earthquake Lateral Load',
		typeOfFoundationProvided: 'Type of foundation provided.',
		soilTestProcedureSystem: 'Soil Test procedure System',
		impactAndDynamicLoad: 'Impact and Dynamic Load',
	},
	table2: {
		loadAction: 'Load Action',
		loadInKnPermissible: 'Load in KN Permissible',
		remarks: 'Remarks',
		dead: 'Dead',
		live: 'Live',
		earthquake: 'Earthquake',
		wind: 'Wind',
		construction: 'Construction',
		seismicLoadingWater: 'Seismic Loading Water and Earth Pressure',
		loadDueToRestrained: 'Load due to restrained volume',
		changeOfMaterialImpact: 'Change of material impact and Dynamic Load',
		blastLoad: 'Blast Load',
		combinationOfLoad: 'Combination Of Load',
	},
	table3: {
		sn: 'S.N.',
		description: 'DESCRIPTION',
		objects: 'OBJECTS',
		remarks: 'REMARKS',
		wallSystem: 'WALL SYSTEM',
		crossWallSystem: 'Cross Wall System',
		longWallSystem: 'Long Wall System',
		twoWaySystem: 'Two Way System',
		shearCoreSystem: 'SHEAR CORE SYSTEM',
		openCore: 'Open Core',
		singleCoreWithLinear: 'Single Core with linear walls',
		arrangementOfCore: 'ARRANGEMENT OF CORE',
		locationOfCore: 'Location of Core',
		exteriorCore: 'Exterior Core',
		interiorCore: 'Interior Core',
		eccentricCore: 'Eccentric Core',
		numberOfCore: 'NUMBER OF CORE',
		singleCore: 'Single Core',
		splitCore: 'Split Core',
		multipleCore: 'Multiple Core',
		shapeOfCore: 'Shape of Core',
		closedForm: 'Closed Form',
		openForm: 'Open Form',
		signatureOfConsultant: 'Signature of Consultant and Seal',
		nceRegdNo: 'NEC Regd. No.',
		commentIfAny: 'Comment if any in short:',
	},
};
